import {V3Record} from 'data/helpers/V3Record.js'

export const FeedItem = V3Record('feedItem', {
  associatedObjectId: null,
  associatedObjectType: null,
  userId: null,
  readStatus: null,
  action: null,
  archived: null,
  content: null,
  createdAt: null,
  updatedAt: null
})
